import { Dialog } from "primereact/dialog";
import { InvoiceSummaryService } from "../InvoiceSummaryService";
import { useEffect, useState } from "react";

interface ViewSummaryDialogProps {
  open: boolean;
  onHide: (open: boolean) => void;
  data: any;
}

export const ViewSummaryDialog = ({
  open,
  onHide,
  data,
}: ViewSummaryDialogProps) => {
  const [pdfSrc, setPdfSrc] = useState("");

  useEffect(() => {
    if (data?.id && open) {
      setPdfSrc(InvoiceSummaryService.getInvoiceSummaryPdfUrl(data.id));
    }
  }, [open, data]);

  return (
    <Dialog
      visible={open}
      style={{ width: "100%", maxWidth: "1600px" }}
      header='Xem in'
      modal
      onHide={() => onHide(false)}
    >
      {pdfSrc && (
        <iframe
          src={pdfSrc}
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
          }}
          title='Summary View'
        />
      )}
    </Dialog>
  );
};
